<template>
	<div>
		Success
	</div>
</template>

<script>
export default {
  name: 'TicketSuccess',

}
</script>

<style lang="scss" scoped>

</style>